import { render, staticRenderFns } from "./TaskItemsList.vue?vue&type=template&id=dd556280&"
import script from "./TaskItemsList.vue?vue&type=script&lang=js&"
export * from "./TaskItemsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports